import type { z } from 'zod'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import { getJoinValue } from './join'
import { getMathValue } from './math'
import type { allValueSchema } from './schema'
import { getSimpleValue } from './simpleValue'
import { getSliceValue } from './slice'

export const getAllValue = ({
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly schema: z.infer<typeof allValueSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): string => {
  if (typeof schema === 'string') {
    // simple value
    return getSimpleValue({
      schema,
      transaction,
      relatedAddresses,
    })
  }

  switch (schema.type) {
    case 'math': {
      // math value
      return getMathValue({ schema, transaction, relatedAddresses }).toString()
    }
    case 'slice': {
      // slice value
      return getSliceValue({
        schema,
        transaction,
        relatedAddresses,
      })
    }
    case 'join': {
      // join value
      return getJoinValue({
        schema,
        transaction,
        relatedAddresses,
      })
    }
    case 'function':
    case 'value':
    case 'chain-id':
    case 'tx-hash':
    case 'from':
    case 'to':
    case 'log':
    case 'erc20':
    case 'erc721':
    case 'erc1155': {
      // simple value
      return getSimpleValue({
        schema,
        transaction,
        relatedAddresses,
      })
    }
    default: {
      throw new Error(`Unknown value type: ${schema satisfies never}`)
    }
  }
}
